import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useRef } from "react"

export default function FileUpload({ onSelect, label = "Upload File", accept="application/pdf,image/*" }) {
    const inputRef = useRef(null)

    const handleChange = (e) => {
        const file = e.target.files?.[0]
        if (file) {
            onSelect(file)
        }
    }

    return (
        <div className="space-y-2">
            <input
                type="file"
                ref={inputRef}
                accept={accept}
                onChange={handleChange}
                className="hidden"
            />

            <Button
                variant="outline"
                onClick={() => inputRef.current?.click()}
            >
                Choose File
            </Button>
        </div>
    )
}
